

import LoginForm from "./pages/LoginForm.vue";
import Sites from "./pages/Sites.vue";
import PortalViewCharts from "./pages/PortalViewCharts.vue";
import Users from "./pages/Users.vue";
import Startup from "./pages/Startup.vue";
import Register from "./pages/Register.vue";
import ClientRequests from "./pages/ClientRequests.vue";
import Clients from "./pages/Clients.vue";
import TermsAndConditions from "./pages/TermsAndConditions.vue";
import Calendar from "./pages/Calendar.vue";

import HelpDocuments from "./components/HelpDocuments.vue";

import Vue from "vue";
import VCalendar from "v-calendar";
Vue.use(VCalendar);

import * as VueGoogleMaps from "vue2-google-maps";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Multiselect from "vue-multiselect";
Vue.component("Multiselect", Multiselect);

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

import axios from "axios";
// import $ from "jquery";
// (window as any).jQuery = $;
// (window as any).$ = $;

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import {
  GetAllClientURL,
  GetFirebaseConfiguration,
  GetMapAPIKey,
  GetParkListURL,
  GetUserURL,
} from "../../shared/Shared";
import ContactUs from "./components/ContactUs.vue";
import {
  UserCredential,
  User as FirebaseUser,
  getAuth,
  RecaptchaVerifier
} from "firebase/auth";

import { initializeApp } from "firebase/app";
import ParkSite from "../../shared/ParkSite";
import User, { roles } from "../../shared/User";
import Client from "../../shared/Client";
import CountryCodes from "../../shared/CountryCodes";
import { TextValue } from "../../shared/TextValue";
import Settings from "../../shared/Settings";

export const firebaseApp = initializeApp(GetFirebaseConfiguration());
export const auth = getAuth(firebaseApp);

class Data {

  public AlertText: string = "";
  public ConfirmText: string = "";

  public StartupDefault = 0;
  public StartupLogin = 1;
  public StartupRegister = 2;

  public Startup = this.StartupDefault;

  public Email: string = "";
  public Password: string = "";

  public IsAuthenticated: boolean = false;
  public Settings: Settings | null = null;

  public LoadingCounter: number = 0;

  public FirebaseUser: FirebaseUser | null = null;
  public User: User | null = null;

  public PromptResult: string = "";

  public PromptResolve:
    | ((value: PromptResult | PromiseLike<PromptResult>) => void)
    | null = null;

  public ConfirmResolve:
    | ((value: boolean | PromiseLike<boolean>) => void)
    | null = null;
}

export const data = new Data();

/*
$.ajaxSetup({
  cache: false,
});*/

const Authorization = "Authorization";

// Gets the current token, or a fresh one if needed, and populates the headers appropriately
function GetCurrentToken(authenticate: boolean, headers: { [id: string]: string }): Promise<void> {

  return new Promise<void>((resolve, reject) => {

    // Don't need a new token if authentication is not needed
    if (authenticate === false) {
      resolve();
      return;
    }

    // We're not authenticated anyway
    if (!data.FirebaseUser) {
      reject("Not authenticated to Firebase");
      return;
    }

    data.FirebaseUser.getIdToken().then((token) => {
      headers[Authorization] = "Bearer " + token;
      resolve();
    }).catch(reject);

  });

}

export function AjaxGet<T>(url: string, authenticate: boolean): Promise<T> {
  return new Promise<T>((resolve, reject) => {

    const headers: { [id: string]: string } = {};
    data.LoadingCounter++;

    GetCurrentToken(authenticate, headers).then(() => {

      return axios
        .get<T>(url, {
          headers,
        });

    }).then((result) => {
      resolve(result.data);
    }).catch((err) => {
      reject(err.response.data);
    }).finally(() => {
      data.LoadingCounter--;
    });

  });
}

export function AjaxPost<T>(
  url: string,
  postData: T,
  authenticate: boolean
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    data.LoadingCounter++;

    const headers: { [id: string]: string } = {};

    GetCurrentToken(authenticate, headers).then(() => {
      return axios
        .post<T>(url, postData, {
          headers,
        });
    }).then((result) => {
      resolve(result.data);
    }).catch((err) => {
      let errorMessage = "";
      if (err.response && err.response.data) {
        errorMessage = err.response.data;
      } else {
        errorMessage = err;
      }
      reject(errorMessage.toString());
    }).finally(() => {
      data.LoadingCounter--;
    });
  });

}

export function AjaxDelete<T>(url: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    data.LoadingCounter++;

    const headers: { [id: string]: string } = {};

    GetCurrentToken(true, headers).then(() => {
      return axios
        .delete<T>(url, {
          headers,
        });
    }).then((result) => {
      resolve(result.data);
    }).catch((err) => {
      reject(err.response.data);
    }).finally(() => {
      data.LoadingCounter--;
    });

  });
}

export function MonthString(): string {
  return MonthStringFormat(new Date());
}

export function MonthStringFromTimestamp(timestamp: number): string {
  const date = new Date();
  date.setTime(timestamp);
  return MonthStringFormat(date);
}

function MonthStringFormat(dateObj: Date): string {
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const year = dateObj.getFullYear();
  return day + "/" + month + "/" + year;
}

export function Clone(source: object): any {
  return JSON.parse(JSON.stringify(source));
}

export function SortOptions(a: any, b: any) {
  if (a.text < b.text) {
    return -1;
  }
  if (a.text > b.text) {
    return 1;
  }
  return 0;
}

Vue.use(Loading);
Vue.component("loading", Loading);

Vue.use(VueGoogleMaps, {
  load: {
    key: GetMapAPIKey(),
    libraries: "places,drawing,visualization", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

export function IsAdmin(): boolean {
  if (!data.User) {
    return false;
  }
  return data.User.role === roles.admin;
}

export function GetClient(
  parkName: string,
  dictionary: { [id: string]: ParkSite }
): string {
  const park = dictionary[parkName];
  if (park && park.council) {
    return park.council;
  }
  return "Unknown";
}

export function GetFilteredCountries(ParkSitesList: ParkSite[]): TextValue[] {
  const dict: { [id: string]: boolean } = {};
  for (const parksite of ParkSitesList) {
    if (parksite.country) {
      dict[parksite.country] = true;
    }
  }

  const result: TextValue[] = [];
  result.push({ text: "Any", value: "", disabled: false });
  for (const key of Object.keys(dict).sort()) {
    let text = CountryCodes[key];
    if (!text) {
      text = "Unknown";
    }

    result.push({ text, value: key, disabled: false });
  }
  return result;
}

export function GetParks(): Promise<{ [key: string]: ParkSite }> {
  return AjaxGet<{ [key: string]: ParkSite }>(GetParkListURL(), true);
}

export function GetClients(): Promise<{ [key: string]: Client }> {
  if (IsAdmin()) {
    return AjaxGet<{ [key: string]: Client }>(GetAllClientURL(), true);
  } else {
    // Immediately resolve an empty promise if we're not an admin
    return new Promise<{ [key: string]: Client }>((resolve, reject) => {
      resolve({});
    });
  }
}

export function Alert(context: string, message: string) {
  appInstance.Alert(context, message);
}

export function Confirm(message: string): Promise<boolean> {
  return appInstance.Confirm(message);
}

export function Transfer(): Promise<boolean> {
  return appInstance.Transfer();
}

export function Prompt(message: string): Promise<PromptResult> {
  return appInstance.Prompt(message);
}

export function ExportToCsv(filename: string, rows: string[][]) {

  const processRow = (row: string[]) => {
    let finalVal = "";
    for (let j = 0; j < row.length; j++) {
      const innerValue = row[j] ? row[j].toString() : "Unknown";
      //      if (row[j] instanceof Date) {
      //      innerValue = row[j].toLocaleString();
      //  };
      let result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0) {
        result = '"' + result + '"';
      }
      if (j > 0) {
        finalVal += ",";
      }
      finalVal += result;
    }
    return finalVal + "\n";
  };

  let csvFile = "";
  for (const row of rows) {
    csvFile += processRow(row);
  }

  const blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
  // if (navigator.msSaveBlob) { // IE 10+
  //   navigator.msSaveBlob(blob, filename);
  //  } else {
  const link = document.createElement("a");
  if (link.download !== undefined) {
    // feature detection
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  //  }
}

let appInstance: any = null;

interface PromptResult {
  clickedOk: boolean;
  text: string;
}

const app = Vue.extend({
  name: "App",
  components: {
    Loading,
    LoginForm,
    Sites,
    Users,
    Startup,
    Register,
    PortalViewCharts,
    ClientRequests,
    HelpDocuments,
    ContactUs,
    TermsAndConditions,
    Clients,
    Calendar,
  },
  data() {
    return data;
  },
  created() {
    appInstance = this;
  },
  methods: {
    Alert(context: string, message: string): void {
      this.AlertText = context.toString() + "</br>" + message.toString();
      this.$bvModal.show("modal-alert");
    },

    Prompt(message: string): Promise<PromptResult> {
      this.ConfirmText = message.toString();
      this.PromptResult = "";
      this.$bvModal.show("modal-prompt");
      return new Promise<PromptResult>((resolve) => {
        this.PromptResolve = resolve;
      });
    },

    Confirm(message: string): Promise<boolean> {
      this.ConfirmText = message.toString();
      this.$bvModal.show("modal-confirm");

      return new Promise<boolean>((resolve) => {
        this.ConfirmResolve = resolve;
      });
    },

    PromptOk() {
      if (this.PromptResolve) {
        this.PromptResolve({ clickedOk: true, text: this.PromptResult });
        this.PromptResolve = null;
      }
    },

    PromptCancel() {
      if (this.PromptResolve) {
        this.PromptResolve({ clickedOk: false, text: this.PromptResult });
        this.PromptResolve = null;
      }
    },

    ConfirmOk() {
      if (this.ConfirmResolve) {
        this.ConfirmResolve(true);
        this.ConfirmResolve = null;
      }
    },
    ConfirmCancel() {
      if (this.ConfirmResolve) {
        this.ConfirmResolve(false);
        this.ConfirmResolve = null;
      }
    },
    IsAdmin,
    userReceived(credential: UserCredential, token: string) {
      // Get the latest settings
      AjaxGet<Settings>(
        "https://magical-parks.firebaseio.com/Settings.json",
        false
      ).then((settings) => {
        this.Settings = settings;

        if (!credential || !credential.user) {
          return;
        }

        data.FirebaseUser = credential.user;

        AjaxGet<User>(
          GetUserURL(),
          true
        ).then((userData) => {
          data.User = userData;
          data.IsAuthenticated = true;
        });
      });
    },
  },
});
export default app;
